import { useContext, useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ReBox from "../../../../common/ReBox";
import LoadingWheel from "../../../../common/LoadingWheel";
import ReactPlayer from "react-player";
import { GlobalContext, FunctionsContext } from "../../../../common/Context";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  STAT_NAMES,
  STAT_CATEGORIES,
  VID_CATEGORIES,
  TRYP_SVGS,
} from "../../../../../constants";
import { text } from "../../../../../theme/colours";
import {
  LEVEL_UP_CAT_BUTTON,
  LEVEL_UP_VOTW_AREA,
} from "../../../../../constants/ids";

const CategorySelection = ({ setObjState }) => {
  const { t } = useTranslation(["LevelUp", "ScoreCategories"]);
  const {
    userState,
    firebaseState,
    desktopView,
    mobileView,
    tabletView,
    setOptionState,
    optionState,
  } = useContext(GlobalContext);
  const { getAllVideos } = useContext(FunctionsContext);

  const [isLoading, setIsLoading] = useState(true);
  const [worstCat, setWorstCat] = useState();
  const [recoVids, setRecoVids] = useState([]);
  const [vidList, setVidList] = useState();
  const [isVideos, setIsVideos] = useState(true);
  const [votwLoad, setVotwLoad] = useState(true);
  const [playing, setPlaying] = useState(false);

  const allVideos = getAllVideos();

  const pageStyle = {
    mt: "1rem",
    width: "100%",
  };
  const titleStyle = { mb: "1rem" };
  const subTitleStyle = {
    width: desktopView ? "65%" : tabletView ? "85%" : "100%",
    mb: "2rem",
  };
  const contentBox = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: mobileView || tabletView ? "column" : "row",
    alignItems: (mobileView || tabletView) && "center",
  };
  const votwAndRecoBoxStyle = {
    display: "flex",
    flexDirection: tabletView ? "row" : "column",
    flexWrap: tabletView && "wrap",
    width: (mobileView || tabletView) && "100%",
    textAlign: "left",
    mr: "2rem",
    height: tabletView && "25rem",
  };
  const votwHeaderBoxStyle = {
    width: "100%",
  };
  const votwHeaderStyle = {
    width: "100%",
    mb: "0.5rem",
  };
  const votwSubStyle = {
    mb: "1rem",
  };
  const votwLoadBox = {
    padding: !(mobileView || tabletView) && "8rem 1rem 0 0",
    position: "relative",
    height: "0%",
  };
  const votwBoxStyle = {
    width: tabletView ? "33%" : "100%",
    display: "flex",
    justifyContent: !mobileView && "center",
    mb: !tabletView && "1rem",
    mr: tabletView && "1rem",
    mt: mobileView && "0.5rem",
    opacity: votwLoad && "0%",
  };
  const votwHolderStyle = {
    width: mobileView ? "50%" : "100%",
  };
  const votwInfoBoxStyle = {
    width: "50%",
    m: "2rem 0 0 1rem",
  };
  const votwTitleStyle = {
    mb: "1rem",
    fontWeight: "900",
  };
  const votwDescStyle = {
    lineHeight: "1.3rem",
  };
  const recVidBoxStyle = {
    width: tabletView ? "60%" : "100%",
    boxShadow: "none",
  };
  const recoVidText = {
    width: "100%",
    padding: "0.5rem",
  };
  const recoStyle = {
    width: "100%",
    p: "0",
    alignItems: "center",
  };
  const vidButtonStyle = {
    width: "100%",
    justifyContent: "flex-start",
    textTransform: "capitalize",
  };
  const recommendedVideosStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };
  const vidTitleStyle = {
    width: tabletView ? "50%" : "100%",
    ml: "0.5rem",
    color: text.primary,
    textAlign: "left",
  };
  const loadBox = {
    height: !(mobileView || tabletView) && "50%",
    position: "relative",
  };
  const dividerStyle = {
    margin: "0 2.75rem 0 2.5rem",
    width: "1px",
    borderLeft: "1px solid #2E117F",
    opacity: "50%",
  };
  const tileAreaStyle = {
    display: "flex",
    flexDirection: "column",
  };
  const catTitleStyle = {
    mb: "0.5rem",
    mt: !desktopView && "2rem",
  };
  const catDescStyle = { mb: "1rem" };
  const boxStyle = {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    width: "100%",
  };
  const tileStyle = {
    padding: "0",
    width: mobileView ? "100%" : "47.5%",
    mb: desktopView ? "2.5rem" : "1.5rem",
    display: "flex",
    flexDirection: mobileView || tabletView ? "column-reverse" : "row",
    alignItems: "center",
  };
  const descBox = {
    display: "flex",
    alignItems: mobileView ? "flex-end" : "center",
    alignSelf: !desktopView && "flex-end",
    margin: desktopView ? "0" : "0.5rem 1rem 1rem 0",
  };
  const descTitleStyle = {
    mr: "0.5rem",
    fontWeight: 800,
  };
  const arrowIconStyle = {
    fontSize: "1rem",
    color: text.primary,
  };
  const leftTile = {
    display: "flex",
    flexDirection: desktopView ? "column" : "row",
    width: desktopView ? "25%" : "100%",
    height: "100%",
    p: mobileView || tabletView ? "1.25rem 1rem 0rem" : "2rem 1rem 1rem 1rem",
  };
  const innerBox = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: desktopView ? "100%" : "33%",
    mb: "1rem",
  };
  const logoCircle = {
    display: "flex",
    justifyContent: "center",
    borderRadius: "50%",
    p: "1rem",
    m: mobileView || tabletView ? "0rem 1rem" : "0rem",
    "& svg": {
      width: mobileView ? "40px" : "30px",
      height: mobileView ? "40px" : "30px",
    },
  };
  const tileIconTitleStyle = {
    mt: "0.5rem",
    fontSize: desktopView ? "0.75rem" : "0.85rem",
    fontWeight: desktopView ? "500" : "700",
    textTransform: "capitalize",
  };
  const rightTile = {
    width: mobileView || tabletView ? "100%" : "75%",
    alignItems: desktopView ? "flex-start" : "left",
    textAlign: mobileView ? "center" : "flex-start",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    height: "100%",
    p: desktopView ? "2.5rem" : "1.5rem",
    borderRadius: desktopView ? "0 0.5rem 0.5rem 0" : "0.5rem 0.5rem 0 0",
  };
  const catTitleBoxStyle = {
    display: "flex",
    flexDirection: desktopView ? "column" : "row",
    alignItems: desktopView ? "left" : "center",
  };
  const mainLogoBoxStyle = {
    mr: desktopView ? "0" : "10%",
    "& svg": {
      width: mobileView ? "70px" : tabletView ? "55px" : "64px",
      height: mobileView ? "70px" : tabletView ? "55px" : "64px",
    },
  };
  const tileTitleStyle = {
    mt: desktopView && "0.5rem",
    fontSize: "1.5rem",
    textTransform: desktopView ? "capitalize" : "uppercase",
  };
  const tileSubTitleStyle = {
    mb: desktopView ? "2rem" : "0.5rem",
    mt: mobileView ? "1.5rem" : "0.5rem",
    fontSize: desktopView ? "0.75rem" : "1rem",
    lineHeight: desktopView ? "1rem" : "1.3rem",
    textAlign: "left",
  };
  const errorAreaStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: window.innerHeight,
  };
  const errorBoxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30%",
    height: "5rem",
  };

  const handleReady = () => {
    setVotwLoad(false);
  };

  useEffect(() => {
    const fetchLowStat = async () => {
      const currentDate = moment();
      const res = await firebaseState.getLowestWeekStat(
        userState?.profileID,
        currentDate.format("YYYY-WW"),
      );
      let catName = "";
      if (res) {
        const lowStat = STAT_NAMES[Object.keys(res)[0]];
        if (STAT_CATEGORIES[lowStat]) {
          catName =
            STAT_CATEGORIES[lowStat][
              Math.floor(Math.random() * STAT_CATEGORIES[lowStat].length)
            ];
        } else {
          catName = lowStat;
        }
      } else {
        catName =
          VID_CATEGORIES[Math.floor(Math.random() * VID_CATEGORIES.length)];
      }
      setWorstCat(catName);
    };
    userState.profileID && fetchLowStat();
  }, [firebaseState, userState]);

  useEffect(() => {
    if (allVideos.error) {
      setIsVideos(false);
      console.error(allVideos.error);
      return;
    }
    if (allVideos.isLoading) {
      setIsLoading(true);
      return;
    }

    setVidList(allVideos.data);
  }, [allVideos]);

  const recoClick = (subCategory, parentCategory, id) => {
    const lowerParent = parentCategory.toLowerCase();
    const category = t("ScoreCategories:categories").find((x) => {
      return x.name.toLowerCase() === lowerParent;
    });
    category && setObjState(category);
    setOptionState({
      nav: "levelUp",
      page: "display",
      recoVidSel: id,
      selSubCat: subCategory.toLowerCase(),
    });
  };

  const handleClick = (obj) => {
    setObjState(obj);
    setOptionState({ nav: "levelUp", page: "display" });
  };

  const votwURL = "https://vimeo.com/679242343/52e1a86614";
  const votwTitle = "Wiper Maintenance";
  const votwDesc =
    "In this video, we teach you everything you need to know about windshield wiper maintenance.";

  useEffect(() => {
    const handleData = () => {
      const filterList = (vidList) => {
        if (!vidList.length) {
          setRecoVids([]);
        } else if (vidList.length === 1) {
          setRecoVids(vidList);
        } else {
          let index1 = Math.floor(Math.random() * vidList.length);
          let index2 = Math.floor(Math.random() * vidList.length);
          if (index1 === index2) {
            index1 === 0 ? index2++ : index2--;
          }
          let filter = [vidList[index1], vidList[index2]];
          setRecoVids(filter);
        }
        setIsLoading(false);
      };
      try {
        if (vidList !== undefined) {
          const filtList = vidList.filter((video) => {
            return video.subCategory.toLowerCase() === worstCat;
          });
          filtList && filterList(filtList);
        } else {
          setIsVideos(false);
        }
      } catch (e) {
        console.error(e.message);
      }
    };
    worstCat && vidList && handleData();
  }, [worstCat, vidList]);

  useEffect(() => {
    if (optionState.nav !== "levelUp" || optionState.page !== "main") {
      setPlaying(false);
    }
  }, [optionState, optionState]);

  return (
    <>
      {isVideos ? (
        <Box sx={pageStyle}>
          <Typography variant="h1" sx={titleStyle}>
            {t("levelUpYourSkills")}
          </Typography>
          <Typography variant="body2" sx={subTitleStyle}>
            {t("levelUpDesc")}
          </Typography>
          <Box sx={contentBox}>
            <Box style={votwAndRecoBoxStyle} id={LEVEL_UP_VOTW_AREA}>
              <Box sx={votwHeaderBoxStyle}>
                <Typography variant="h3" sx={votwHeaderStyle}>
                  {t("videoOfTheWeek")}
                </Typography>
                {desktopView && (
                  <Typography variant="body1" sx={votwSubStyle}>
                    {t("votwDesc")}
                  </Typography>
                )}
              </Box>
              {votwLoad && (
                <Box sx={votwLoadBox}>
                  <LoadingWheel width={5} />
                </Box>
              )}
              <Box sx={votwBoxStyle}>
                <Box sx={votwHolderStyle}>
                  <ReactPlayer
                    url={votwURL}
                    controls="true"
                    width={desktopView ? "300px" : "100%"}
                    height={
                      desktopView ? "540px" : tabletView ? "100%" : "260px"
                    }
                    onReady={() => handleReady()}
                    onPlay={() => setPlaying(true)}
                    playing={playing}
                  />
                </Box>
                {mobileView && (
                  <Box sx={votwInfoBoxStyle}>
                    <Typography variant="body1" sx={votwTitleStyle}>
                      {votwTitle}
                    </Typography>
                    <Typography variant="body1" sx={votwDescStyle}>
                      {votwDesc}
                    </Typography>
                  </Box>
                )}
              </Box>
              <ReBox style={recVidBoxStyle}>
                <Typography variant="h3" sx={recoVidText}>
                  {t("recommendedVideos")}
                </Typography>
                {!isLoading ? (
                  recoVids.map((video, i) => (
                    <Box button={true} style={recoStyle} key={i}>
                      <Button
                        sx={vidButtonStyle}
                        onClick={() =>
                          recoClick(video.subCategory, video.category, video.id)
                        }>
                        <Box sx={recommendedVideosStyle}>
                          <ReactPlayer
                            url={video.url}
                            controls="false"
                            width={tabletView ? "6rem" : "62px"}
                            height={tabletView ? "8rem" : "80px"}
                          />
                          <Typography variant="h4" sx={vidTitleStyle}>
                            {video.title}
                          </Typography>
                        </Box>
                      </Button>
                    </Box>
                  ))
                ) : (
                  <Box sx={loadBox}>
                    <LoadingWheel width={5} />
                  </Box>
                )}
              </ReBox>
            </Box>
            {mobileView || tabletView ? null : <Box sx={dividerStyle} />}
            <Box sx={tileAreaStyle}>
              <Typography variant="h3" sx={catTitleStyle}>
                {t("videoCategories")}
              </Typography>
              <Typography variant="body1" sx={catDescStyle}>
                {t("videoCategoriesDesc")}
              </Typography>
              <Box sx={boxStyle}>
                {t("ScoreCategories:categories").map((category, i) => (
                  <ReBox
                    style={tileStyle}
                    button={true}
                    clickHandler={() => handleClick(category)}
                    key={i}>
                    {!desktopView ? (
                      <Box sx={descBox}>
                        <Typography variant="h4" sx={descTitleStyle}>
                          {t("seeVideos")}
                        </Typography>
                        <ArrowForwardIcon sx={arrowIconStyle} />
                      </Box>
                    ) : null}
                    <Box sx={leftTile}>
                      {category.subCat.map((subCategory, i) => (
                        <Box sx={innerBox} key={i}>
                          <Box
                            sx={{
                              ...logoCircle,
                              bgcolor: category.color,
                              "& svg *": {
                                fill: category.logoColor,
                              },
                            }}>
                            {TRYP_SVGS[subCategory.img]}
                          </Box>
                          <Typography
                            variant="body1"
                            color={category.logoColor}
                            sx={tileIconTitleStyle}>
                            {subCategory.name}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                    <Box
                      sx={{ ...rightTile, bgcolor: category.color }}
                      id={LEVEL_UP_CAT_BUTTON(category.name)}>
                      <Box sx={catTitleBoxStyle}>
                        <Box
                          sx={{
                            ...mainLogoBoxStyle,
                            "& svg *": {
                              fill: category.logoColor,
                            },
                          }}>
                          {TRYP_SVGS[category.img]}
                        </Box>
                        <Typography
                          variant="h3"
                          color={category.logoColor}
                          sx={tileTitleStyle}>
                          {category.name}
                        </Typography>
                      </Box>
                      <Typography variant="body1" sx={tileSubTitleStyle}>
                        {category.desc}
                      </Typography>
                      {desktopView ? (
                        <Box sx={descBox}>
                          <Typography variant="h4" sx={descTitleStyle}>
                            {t("seeVideos")}
                          </Typography>
                          <ArrowForwardIcon sx={arrowIconStyle} />
                        </Box>
                      ) : null}
                    </Box>
                  </ReBox>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={errorAreaStyle}>
          <ReBox sx={errorBoxStyle}>
            <Typography variant="h3">{t("videoError")}</Typography>
          </ReBox>
        </Box>
      )}
    </>
  );
};

export default CategorySelection;
